const BASE_URLS = {
  auth: "https://authmodule.panel.qualsights.com",
  reports: "https://reportsmodule.panel.qualsights.com",
  coaster: "https://coasterchart.panel.qualsights.com",
  xmot: "https://xmots.panel.qualsights.com",
};

export const getApiBaseUrl = (module) => {
  switch (module) {
    case "auth":
      return BASE_URLS.auth;
    case "reports":
      return BASE_URLS.reports;
    case "coaster":
      return BASE_URLS.coaster;
    case "xmot":
      return BASE_URLS.xmot;
    default:
      throw new Error(`Unknown module: ${module}`);
  }
};
